import styled from 'styled-components';

import { media } from 'utils/detection';
import Img from 'components/Img';

const StyledImg = styled(Img)`
  position: relative;
  width: calc(100% + 80px);
  height: 264px;
  margin: 40px 0 0 -40px;

  ${media.medium`
    width: 100vw;
    height: 25vw;
    margin: 6vw 0 0 -14vw;
  `}
`;

StyledImg.defaultProps = {
  position: '50% 0',
};

export default StyledImg;